import style from "./SupportPage.module.scss";

export function SupportPage() {
    return (
        <main className={style.page}>
            <p className={style.pageName}>Підтримка</p>
            <div className={style.container}>
                <div className="p-[50px] max-sm:p-[30px]">
                    <p className={style.title}>Залишились питання?</p>
                    <p className={style.desct}>Напишіть нам і задайте питання, яке вас цікавить</p>
                    <a href="https://t.me/RocketProxy_bot" target="_blank" rel="noopener noreferrer" className={style.button} type="button">
                        <div className={style.rectangle}>
                            <p>Задати питання</p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="12" viewBox="0 0 27 12" fill="none">
                                <path d="M26.495 6.49497C26.7683 6.22161 26.7683 5.77839 26.495 5.50503L22.0402 1.05025C21.7668 0.776886 21.3236 0.776886 21.0503 1.05025C20.7769 1.32362 20.7769 1.76684 21.0503 2.0402L25.01 6L21.0503 9.9598C20.7769 10.2332 20.7769 10.6764 21.0503 10.9497C21.3236 11.2231 21.7668 11.2231 22.0402 10.9497L26.495 6.49497ZM0 6.7H26V5.3H0V6.7Z" fill="white" />
                            </svg>
                        </div>
                        <div className={style.circle}></div>
                        <div className={style.telegramSvg}>
                            <TelegramSVG />
                        </div>
                    </a>
                </div>
                <img className="absolute right-[40px] bottom-0 max-lg:hidden" src="./image/support/human.png" alt="human" />
            </div>
        </main>
    )
}

function TelegramSVG() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="96" height="97" viewBox="0 0 96 97" fill="none">
            <g filter="url(#filter0_d_2335_15884)">
                <circle cx="47.9997" cy="47.0006" r="24.0006" fill="#1D9AEC" />
                <path d="M56.6498 36.6268C56.6498 36.6268 58.9811 35.7178 58.7868 37.9254C58.7221 38.8344 58.1393 42.016 57.6859 45.4574L56.1318 55.6515C56.1318 55.6515 56.0023 57.1448 54.8367 57.4046C53.671 57.6643 51.9226 56.4956 51.5988 56.2358C51.3398 56.041 46.7421 53.1191 45.1231 51.6907C44.6698 51.3011 44.1518 50.5219 45.1879 49.6129L51.9874 43.1199C52.7644 42.3407 53.5415 40.5227 50.3037 42.7303L41.2377 48.8987C41.2377 48.8987 40.2016 49.548 38.2589 48.9636L34.0497 47.665C34.0497 47.665 32.4956 46.6911 35.1506 45.7171C41.6263 42.6653 49.5914 39.5486 56.6498 36.6268Z" fill="white" />
            </g>
            <defs>
                <filter id="filter0_d_2335_15884" x="-0.00160599" y="0.599413" width="96.0022" height="96.0032" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.60004" />
                    <feGaussianBlur stdDeviation="12.0003" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.333333 0 0 0 0 0.73591 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2335_15884" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2335_15884" result="shape" />
                </filter>
            </defs>
        </svg>
    )
}